import { render, staticRenderFns } from "./Dialog_ChooseClass.vue?vue&type=template&id=147c2434&scoped=true&"
import script from "./Dialog_ChooseClass.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseClass.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_ChooseClass.vue?vue&type=style&index=0&id=147c2434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c2434",
  null
  
)

export default component.exports